// extracted by mini-css-extract-plugin
export default {"container":"Container_container__PL8tM","color-default":"Container_color-default__bZC+T","color-error":"Container_color-error__vWxpT"};